import { COLORS } from '@btime/constants'
import React from 'react'

import { useBucket } from './_load/BucketLoader'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import { usePrintPdf } from '../../../components/pdf/options/_helpers/printPdf'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'

const PageHeader = () => {
  const bucket = useBucket()
  const title = bucket.name
  const [loading, print] = usePrintPdf(title)
  const navigate = useNavigation()

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(-1)}
      title={title}
      mediumPadding
      noContainer
      side={
        <Link onClick={print} block loading={loading} loadingColor={COLORS.white} loadingBgColor={COLORS.purple}>
          <IconText
            iconSize="1.4rem"
            weight="700"
            iconName="RiDownloadCloud2Line"
            color={COLORS.white}
            label="Gerar PDF"
            noWrap
          />
        </Link>
      }
    />
  )
}

export default PageHeader
